import React from 'react';
import { Container } from './FormError.styles';
import { useTranslations } from '@lang';

type FormErrorProps = {
  error: unknown;
};

export function FormError({ error }: FormErrorProps) {
  const { t } = useTranslations();

  let message = t('error.global');

  if (error instanceof Error) {
    message = error.message;
  }

  return <Container>{message}</Container>;
}
